import React from 'react'
import { ConversationMessageThread } from '../shared/ConversationMessageThread'
import { ConversationReviewTile } from './ConversationReviewTile'
import type { ConversationContentProps } from './ConversationContent'

export const ReviewConversationContent: React.FC<ConversationContentProps> = ({ conversation }) => (
  <ConversationMessageThread
    messages={conversation.messages}
    firstGroupContent={<ConversationReviewTile review={conversation.review} />}
  />
)
